import { render, staticRenderFns } from "./popup-customer.vue?vue&type=template&id=6787a862&scoped=true&"
import script from "./popup-customer.vue?vue&type=script&lang=js&"
export * from "./popup-customer.vue?vue&type=script&lang=js&"
import style0 from "./popup-customer.vue?vue&type=style&index=0&id=6787a862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787a862",
  null
  
)

export default component.exports